import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { Tag } from '../Tag/Tag.js';
import { jsx } from 'react/jsx-runtime';

var TagsWrapper = styled.span.withConfig({
  displayName: "Tags__TagsWrapper",
  componentId: "sc-1og2dz5-0"
})(["&& > span{margin:3px 5px 3px 0;}&& > span:last-child{margin-inline-end:0;}"]);
var Tags = /*#__PURE__*/React.forwardRef(function Tags2(props, ref) {
  return /*#__PURE__*/jsx(TagsWrapper, {
    ref: ref,
    children: props.tags.map(function (tag, index) {
      return /*#__PURE__*/jsx(Tag, _objectSpread({}, tag), index);
    })
  });
});
Tags.propTypes = {
  "tags": _PropTypes.arrayOf(_PropTypes.object).isRequired
};
Tags.displayName = "Tags";

export { Tags };
